<template>
    <div>
        <card-header title="New Task" icon="fa-plus"/>

        <card-body>
            <task-form :task="newTask"/>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" :disabled="!newTask.title" @click="submit"><i class="fas fa-plus mr-3"></i>New Task</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from '../../TIER/components/CardHeader';
    import CardFooter from "../../TIER/components/CardFooter";
    import CardBody from "../../TIER/components/CardBody";
    import TaskForm from "@/cards/tasks/TaskForm";

    import {client as http} from '../../http_client';
    import {mapActions} from "vuex";

    export default {
        props: ['card', 'props'],
        components: {TaskForm, CardBody, CardFooter, CardHeader},
        data: function () {
            return {
                newTask: {
                    type: 'general',
                    status: null,
                    payment: null,
                    assigned_id: null,
                    complete: 0
                }
            };
        },
        methods: {
            ...mapActions(['updateTasks']),
            submit() {
                this.$emit('loading', true);
                http.post('/api/tasks', {
                    ...this.newTask,
                    entity_type: this.props.entityType,
                    entity_id: this.props.entityId
                }, {force: true}).then(response => {
                    this.updateTasks();
                    this.$reloadCard('tasks');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    console.log('An error occurred.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.$saveAlert(true, 'Are you done creating this new task? Unsaved changes will be lost.');
        }
    };
</script>
